module.exports = __webpack_public_path__ + "static/media/SeePicKnowWord.beebb873.jpg";